





























import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { ContactApi } from '../api/contact';
import AppMessage from 'modules/core/models/appMessage';
import { ElForm } from 'element-ui/types/form';

@Component
export default class Contact extends Vue {
  public loading: boolean = false;
  public formRules!: any;
  public form = {
    subject: '',
    message: '',
  };
  private api: ContactApi;

  constructor() {
    super();
    this.api = new ContactApi();
  }

  public async created() {
    this.formRules = {
      subject: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
      message: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
    };
  }

  public submitForm() {
    this.loading = true;
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.api.send(this.form.subject, this.form.message).then((status: boolean) => {
          AppMessage.show(this.$t('contact.sendSuccess'), 'success');
          this.loading = false;
          this.form = {
            subject: '',
            message: '',
          };
        }).catch((error: any) => {
          this.loading = false;
        });
      } else {
        this.loading = false;
        return false;
      }
    });
  }
}
